// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-card-header p {
    margin: 0;
}

.customer-card-header .phone {
    color: #DA512D;
}

.policyThumb li img {
    height: 200px;
    padding: 4px 0;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    background-color: #dfe7ed;
    border-radius: 5px;
    margin-bottom: 10px;
}

.policyThumb li p {
    margin: 0;
}

.cutomer-action-btn li button {
    color: rgba(0, 0, 0, 0.6);
}

.policyThumb li .date {
    color: #98bcd5;
}

.profilePreview {
    width: 180px;
    height: 180px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

.profilePreview img {
    width: 100%;
}

.logoFileBtn {
    position: relative;
    bottom: 15px;
    color: #98bcd5;
    font-size: 16px;
}

tr.policy .pdfLink {
    display: none;
}

tr.policy:hover .pdfLink {
    display: block;
}

tr.mat-header-row,
th.mat-header-row {
    border-bottom: 1px solid #000 !important;
}

.totalPoint {
    font-size: 36px;
    font-weight: bold;
    color: #DA512D;
}

.btn-print {
    background-color: #222c4a;
    color: #FFF;
    margin: 5px;
}

.example-radio-group {
    display: flex;
    flex-direction: column;
    margin: 15px 0;
}

.example-radio-button {
    margin: 5px;
}

.preference{
    margin-top: 10px;
    font-size: 12px;
}

/* Graph steper */


/* .stper1:before {
    content: '';
    width: 5px;
    height: 100%;
    background: #DA512D;
    position: absolute;
} */

.stper1,
.stper2,
.stper3,
.stper4 {
    margin-top: 7px;
    height: 57px;
    width: 2px;
    position: absolute;
}

.stper1 {
    border-left: 2px solid #39B54A;
}

.stper2 {
    left: 51px;
    border-left: 2px solid #222C4A;
}

.stper3 {
    left: 85px;
    border-left: 2px solid #98BCD5;
}

.stper4 {
    left: 119px;
    ;
}

.steprCircle {
    height: 8px;
    border-radius: 50%;
    width: 8px;
    position: absolute;
    left: -5px;
    top: calc(50% - 24px);
}

.stper1 .steprCircle {
    background-color: #39B54A;
}

.stper2 .steprCircle {
    background-color: #222C4A;
}

.stper3 .steprCircle {
    background-color: #98BCD5;
}

.stper-space-1 {
    margin-left: 68px;
}

.stper-space-2 {
    margin-left: 102px;
}

.stper-space-3 {
    margin-left: 119px;
}

.first-stper {
    margin-top: 4px;
}

.steprCircle.first-stper-circle,
.dot-circle {
    color: #FFF;
    font-size: 12px;
    width: 18px;
    height: 18px;
    left: -10px;
    top: calc(50% - 28px);
    text-align: center;
    font-style: normal;
    margin-top: -2px;
}

.lastStper {
    margin-top: -14px;
}

.lastStper .steprCircle {
    top: 20px;
}

.referees td,
.referees th {
    padding: 10px 0;
}

table.referees>tbody>tr:last-child .stper1,
table.referees>tbody>tr:last-child .stper2,
table.referees>tbody>tr:last-child .stper3,
.no-border {
    border-color: transparent;
}

@media screen and (max-width:992px) {
    .col-3{
        max-width: 100% !important;
    }
    .w-75{
        max-width: 100% !important;
    }
}

.download-text {
  cursor: pointer !important;
  font-size: 13px;
  color: #da512d !important;
  font-weight: 500 !important;
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/secure/users/user-detail/user-detail.component.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yHAAyH;IACzH,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,iBAAiB;;;AAGjB;;;;;;GAMG;;AAEH;;;;IAII,eAAe;IACf,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA,wmNAAwmN","sourcesContent":[".customer-card-header p {\n    margin: 0;\n}\n\n.customer-card-header .phone {\n    color: #DA512D;\n}\n\n.policyThumb li img {\n    height: 200px;\n    padding: 4px 0;\n    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n    background-color: #dfe7ed;\n    border-radius: 5px;\n    margin-bottom: 10px;\n}\n\n.policyThumb li p {\n    margin: 0;\n}\n\n.cutomer-action-btn li button {\n    color: rgba(0, 0, 0, 0.6);\n}\n\n.policyThumb li .date {\n    color: #98bcd5;\n}\n\n.profilePreview {\n    width: 180px;\n    height: 180px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n\n.profilePreview img {\n    width: 100%;\n}\n\n.logoFileBtn {\n    position: relative;\n    bottom: 15px;\n    color: #98bcd5;\n    font-size: 16px;\n}\n\ntr.policy .pdfLink {\n    display: none;\n}\n\ntr.policy:hover .pdfLink {\n    display: block;\n}\n\ntr.mat-header-row,\nth.mat-header-row {\n    border-bottom: 1px solid #000 !important;\n}\n\n.totalPoint {\n    font-size: 36px;\n    font-weight: bold;\n    color: #DA512D;\n}\n\n.btn-print {\n    background-color: #222c4a;\n    color: #FFF;\n    margin: 5px;\n}\n\n.example-radio-group {\n    display: flex;\n    flex-direction: column;\n    margin: 15px 0;\n}\n\n.example-radio-button {\n    margin: 5px;\n}\n\n.preference{\n    margin-top: 10px;\n    font-size: 12px;\n}\n\n/* Graph steper */\n\n\n/* .stper1:before {\n    content: '';\n    width: 5px;\n    height: 100%;\n    background: #DA512D;\n    position: absolute;\n} */\n\n.stper1,\n.stper2,\n.stper3,\n.stper4 {\n    margin-top: 7px;\n    height: 57px;\n    width: 2px;\n    position: absolute;\n}\n\n.stper1 {\n    border-left: 2px solid #39B54A;\n}\n\n.stper2 {\n    left: 51px;\n    border-left: 2px solid #222C4A;\n}\n\n.stper3 {\n    left: 85px;\n    border-left: 2px solid #98BCD5;\n}\n\n.stper4 {\n    left: 119px;\n    ;\n}\n\n.steprCircle {\n    height: 8px;\n    border-radius: 50%;\n    width: 8px;\n    position: absolute;\n    left: -5px;\n    top: calc(50% - 24px);\n}\n\n.stper1 .steprCircle {\n    background-color: #39B54A;\n}\n\n.stper2 .steprCircle {\n    background-color: #222C4A;\n}\n\n.stper3 .steprCircle {\n    background-color: #98BCD5;\n}\n\n.stper-space-1 {\n    margin-left: 68px;\n}\n\n.stper-space-2 {\n    margin-left: 102px;\n}\n\n.stper-space-3 {\n    margin-left: 119px;\n}\n\n.first-stper {\n    margin-top: 4px;\n}\n\n.steprCircle.first-stper-circle,\n.dot-circle {\n    color: #FFF;\n    font-size: 12px;\n    width: 18px;\n    height: 18px;\n    left: -10px;\n    top: calc(50% - 28px);\n    text-align: center;\n    font-style: normal;\n    margin-top: -2px;\n}\n\n.lastStper {\n    margin-top: -14px;\n}\n\n.lastStper .steprCircle {\n    top: 20px;\n}\n\n.referees td,\n.referees th {\n    padding: 10px 0;\n}\n\ntable.referees>tbody>tr:last-child .stper1,\ntable.referees>tbody>tr:last-child .stper2,\ntable.referees>tbody>tr:last-child .stper3,\n.no-border {\n    border-color: transparent;\n}\n\n@media screen and (max-width:992px) {\n    .col-3{\n        max-width: 100% !important;\n    }\n    .w-75{\n        max-width: 100% !important;\n    }\n}\n\n.download-text {\n  cursor: pointer !important;\n  font-size: 13px;\n  color: #da512d !important;\n  font-weight: 500 !important;\n  display: inline-flex;\n  align-items: center;\n  margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
